<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">合同验收记录</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回合同详情</a>
    </div>
    <div class="form-content" v-if="contract.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">

          <create-end ref="create" :contract="contract" :userData="userData" :formByFather="form"></create-end>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments :projectId="form.projectId" :contractId="form.contractId" ref="attachments" :type='991'
                :arr="attachmentArr">
              </attachments>
            </el-form-item>
          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button :loading="formLoading" @click="createProject()" class="form-btn" type="success">确认提交合同验收记录
              </el-button>
            </div>
          </el-form-item>

        </el-form>
      </el-col>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import Attachments from '@/components/Attachments'
  import CreateEnd from '@/page/form/createContractEnd'
  export default {
    components: {
      CreateEnd,
      Attachments,
    },
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        contract: {},
        ysInfo: {},
        form: {
          contractId: '',
          ysqksm: "",
          yssj: "",
        },
        formLoading: false,
        // 附件
        attachmentArr: [],
      }
    },
    mounted() {
      this.form.contractId = this.$route.params.contractId
      this.getProject()
      this.getYsInfo()
    },
    methods: {
      // 验收登记
      getYsInfo() {
        ajax.get('/contract/ys/info/' + this.form.contractId, '', (res) => {
          this.ysInfo = res.vo ? res.vo : ""
          if (this.ysInfo) {
            this.attachmentArr = this.ysInfo.ysAttachments ? this.ysInfo.ysAttachments : []
            this.form.yssj = this.ysInfo.yssj
            this.form.ysqksm = this.ysInfo.ysqksm
          }
        })
      },
      // 获取合同
      getProject() {
        ajax.get('/contract/info/' + this.form.contractId, '', (res) => {
          this.contract = res.vo
          this.form.intro = this.contract.intro
        })
      },
      // 提交合同申请
      createProject() {
        if (!this.form.yssj) {
          this.$message.error("请准确填写合同验收时间")
          return
        }

        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        ajax.post('/contract/ys', this.form, (res) => {
          this.$message.success("提交合同验收记录成功")
          this.$router.back()
          this.formLoading = false
        }, (res) => {
          this.formLoading = false
        })
      },
    },
    watch: {}
  };
</script>


// WEBPACK FOOTER //
// src/page/contract/createEnd.vue